export default __webpack_public_path__ + "static/media/appstore.5c19dc76.png";